import { FormFields } from 'app/modules/filingFormGenerator/models';
import {
  dateField,
  prefixFields,
  repeatableSection,
  selectField,
  textField,
  textareaField,
} from 'app/modules/goAML/formConfig/fields/fieldBuilders';
import { getAddressFields } from 'app/modules/goAML/formConfig/fields/addressFields';
import { getPersonTransactionFields } from 'app/modules/goAML/formConfig/fields/personFields';
import { getPhoneFields } from 'app/modules/goAML/formConfig/fields/phoneFields';
import { GoamlReferenceTables } from 'app/modules/goAML/queries/useGetGoamlFiuConfig';

type FieldValues = Record<string, any>;

const getEntityRawFields = (
  referenceTables: GoamlReferenceTables,
  opts?: { myClient?: boolean },
): FormFields<FieldValues> => {
  const myClient = opts?.myClient ?? false;

  return [
    textField({ name: 'name', label: 'Name', required: true }),
    textField({ name: 'commercial_name', label: 'Commercial name' }),
    selectField(
      {
        name: 'incorporation_legal_form',
        label: 'Incorporation legal form type',
        required: true,
        refTable: 'legal_form',
      },
      referenceTables,
    ),
    textField({
      name: 'incorporation_number',
      label: 'Incorporation number',
      required: myClient,
    }),
    textField({
      name: 'business',
      label: 'Type of business',
      required: myClient,
    }),
    textField({ name: 'email', label: 'Email' }),
    textField({ name: 'url', label: 'URL' }),
    textField({ name: 'incorporation_state', label: 'Incorporation state' }),
    selectField(
      {
        name: 'incorporation_country_code',
        label: 'Incorporation country',
        required: myClient,
        refTable: 'country_code',
      },
      referenceTables,
    ),
    dateField({
      name: 'incorporation_date',
      label: 'Incorporation date',
      required: myClient,
    }),
    selectField({
      name: 'business_closed',
      label: 'Business closed?',
      options: [
        { value: '0', text: 'No' },
        { value: '1', text: 'Yes' },
      ],
    }),
    dateField({ name: 'date_business_closed', label: 'Date business closed' }),
    textField({ name: 'tax_number', label: 'Tax number' }),
    textField({ name: 'tax_reg_number', label: 'Tax registration number' }),
    textareaField({ name: 'comments', label: 'Comments' }),
  ];
};

const getEntityNestedFields = (
  referenceTables: GoamlReferenceTables,
): FormFields<FieldValues> => [
  repeatableSection({
    name: 'phones',
    label: 'Phones',
    fields: getPhoneFields(referenceTables),
  }),
  repeatableSection({
    name: 'addresses',
    label: 'Addresses',
    fields: getAddressFields(referenceTables),
  }),
];

export const getEntityFields = (
  referenceTables: GoamlReferenceTables,
): FormFields<FieldValues> => [
  ...getEntityRawFields(referenceTables),
  ...getEntityNestedFields(referenceTables),
];

export const getEntityMyClientFields = (
  referenceTables: GoamlReferenceTables,
): FormFields<FieldValues> => [
  ...getEntityRawFields(referenceTables, { myClient: true }),
  ...getEntityNestedFields(referenceTables),
  selectField(
    {
      name: 'director_id.role',
      label: 'Role',
      required: true,
      defaultValue: 'D',
      refTable: 'entity_person_role',
    },
    referenceTables,
  ),
  ...prefixFields(
    'director_id',
    getPersonTransactionFields(referenceTables, { myClient: true }),
  ),
];
